(function ($) {
    $(document).ready(function () {
        function checkCarouselBtn() {
            $('.collection-text__head__nav .carousel-btn').each(function() {
                const dataDirection = $(this).attr('data-direction');
                const sliderBtn = $(this).closest('.collection-text').find(`.slider-grid .carousel-btn[data-direction="${dataDirection}"]`);
                if ($(sliderBtn).is('[disabled]')) {
                    $(this).prop('disabled', true);
                } else {
                    $(this).prop('disabled', false);
                }
            });
        }

        setTimeout(function() {
            checkCarouselBtn();
        },1000)

        $(document).on('click', '.collection-text__head__nav .carousel-btn', function() {
            const dataDirection = $(this).attr('data-direction');
            const sliderBtn = $(this).closest('.collection-text').find(`.slider-grid .carousel-btn[data-direction="${dataDirection}"]`);
            $(sliderBtn).trigger('click');

            setTimeout(function() {
                checkCarouselBtn();
            },100)
        });

        $(document).on('click', '.content-with-accordion.use-new-style .accordeon-plus__btn', function(e) {
            const block = $(this).closest('.content-with-accordion')
            const item = $(this);
            const accordeonComponent = $(this).closest('accordeon-component');
            const img = $(accordeonComponent).attr('data-img');
            const mainImg = $(block).find('.content-with-accordion__image-img');
            const mainImgUrl = $(block).attr('data-main-img');
            const activeAccordeon = $(block).find('.accordeon-plus[data-aria-expanded="true"]').not($(item).closest('.accordeon-plus'));


            if($(item).hasClass('m-active')) {
                $(item).removeClass('m-active');
            } else {
                if(img.length) {
                    $(mainImg).attr('src', img);
                } else {
                    $(mainImg).attr('src', mainImgUrl);
                }
                $(activeAccordeon).trigger('click');
                $(activeAccordeon).each(function() {
                    console.log($(this).find('.accordeon-plus__btn'))
                    $(this).find('.accordeon-plus__btn').trigger('click')
                });
                $(this).addClass('m-active');
            }
        });
    });
})(jQuery);